module.exports = __webpack_public_path__ + "static/media/11_Yasser.b93636aa.jpg";